export default {
  root: {
    class: 'overflow-x-auto'
  },
  menu: {
    class: [
      // Flexbox
      'flex flex-1',

      // Spacing
      'list-none',
      'p-0 m-0',

      // Colors
      'bg-secondary-0 dark:bg-secondary-800',
      'border-b-2 border-secondary-200 dark:border-secondary-700',
      'text-secondary-900 dark:text-secondary-0/80'
    ]
  },
  menuitem: {
    class: 'mr-0'
  },
  action: ({ context, state }) => ({
    class: [
      'relative',

      // Font
      'font-bold',

      // Flexbox and Alignment
      'flex items-center',

      // Spacing
      'py-2 px-4',
      '-mb-[2px]',

      // Shape
      'border-b-2',
      'rounded-t-md',

      // Colors and Conditions
      {
        'border-secondary-200 dark:border-secondary-700': state.d_activeIndex !== context.index,
        'bg-secondary-0 dark:bg-secondary-800': state.d_activeIndex !== context.index,
        'text-secondary-700 dark:text-secondary-0/80': state.d_activeIndex !== context.index,

        'bg-secondary-0 dark:bg-secondary-800': state.d_activeIndex === context.index,
        'border-primary-500 dark:border-primary-400': state.d_activeIndex === context.index,
        'text-primary-500 dark:text-primary-400': state.d_activeIndex === context.index
      },

      // States
      'focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset',
      'focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50',
      {
        'hover:bg-secondary-0 dark:hover:bg-secondary-800/80': state.d_activeIndex !== context.index,
        'hover:border-secondary-400 dark:hover:border-primary-400': state.d_activeIndex !== context.index,
        'hover:text-secondary-900 dark:hover:text-secondary-0': state.d_activeIndex !== context.index
      },

      // Transitions
      'transition-all duration-200',

      // Misc
      'cursor-pointer select-none text-decoration-none',
      'overflow-hidden',
      'user-select-none'
    ]
  }),
  icon: {
    class: 'mr-2'
  }
};
